<template>
    <div id="notifyDetail">
        <section class="header">
            <h3>{{ notifyDetail.title }}</h3>
            <label>{{ notifyDetail.currentTime }}</label>
        </section>
        <section class="content">
            <p v-html="showTxt(notifyDetail.content)"></p>
        </section>
    </div>    
</template>
<script>
export default {
    name: 'notifyDetail',
    data(){
        return {
            notifyDetail: {}
        }
    },
    methods:{
        showTxt(content){
            return content.replace(/\n/g, '<br>');
        }
    },
    created(){
        this.notifyDetail = this.$route.query;
    }
}
</script>
<style lang="less" scoped>
#notifyDetail {
    padding: 15px 3%;
    .header {
        padding-bottom: 10px;
        border-bottom: 1px solid #e5e5e5;
        h3 {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 12px;
        }    
        label {
            font-size: 13px;
            color:#838383;
        }    
    }
    .content {
        font-size: 16px;
        line-height: 1.8em;
        padding-top: 10px;
        p {
            // text-indent: 2em;
        }        
    }
}
</style>

